import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { showMessage } from 'react-native-flash-message';
import { Colors, Typography } from '../theme';

const TONYTE_LOGO = require('../assets/login_logo.png');

type InAppNotificationOptions = {
  title: string;
  description: string;
  onPress?: () => void;
  sender?: {
    name: string;
    photoUrl?: string;
  };
};

export function showInAppNotification({ title, description, onPress, sender }: InAppNotificationOptions): void {
  const isChatMessage = Boolean(sender);
  const icon = isChatMessage && sender?.photoUrl
    ? <Image source={{ uri: sender.photoUrl }} style={styles.avatar} />
    : isChatMessage
      ? (
        <View style={styles.avatarFallback}>
          <Text style={styles.avatarInitial}>{sender?.name.trim().slice(0, 1).toUpperCase() || '?'}</Text>
        </View>
      )
      : <Image source={TONYTE_LOGO} style={styles.logo} resizeMode="contain" />;

  showMessage({
    message: isChatMessage ? sender?.name || title : title,
    description,
    type: 'info',
    icon: { icon: 'info', position: 'left', props: {} },
    renderFlashMessageIcon: () => icon,
    duration: 5000,
    animated: true,
    animationDuration: 240,
    floating: true,
    hideOnPress: true,
    backgroundColor: '#081522',
    color: '#FFFFFF',
    style: styles.card,
    titleStyle: styles.title,
    textStyle: styles.description,
    renderBeforeContent: isChatMessage
      ? () => <Text style={styles.eyebrow}>NEW MESSAGE</Text>
      : undefined,
    onPress,
  });
}

const styles = StyleSheet.create({
  card: {
    minHeight: 76,
    marginTop: 10,
    marginHorizontal: 12,
    paddingHorizontal: 14,
    paddingVertical: 11,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: 'rgba(38,208,206,0.46)',
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.38,
    shadowRadius: 16,
    elevation: 16,
  },
  avatar: {
    width: 46,
    height: 46,
    borderRadius: 23,
    borderWidth: 1.5,
    borderColor: 'rgba(38,208,206,0.72)',
    backgroundColor: '#152334',
  },
  avatarFallback: {
    width: 46,
    height: 46,
    borderRadius: 23,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1.5,
    borderColor: 'rgba(38,208,206,0.72)',
    backgroundColor: 'rgba(38,208,206,0.16)',
  },
  avatarInitial: {
    color: Colors.turquoise,
    fontSize: 18,
    fontWeight: Typography.extrabold,
  },
  logo: {
    width: 43,
    height: 43,
  },
  eyebrow: {
    color: Colors.turquoise,
    fontSize: 9,
    lineHeight: 11,
    fontWeight: Typography.extrabold,
    letterSpacing: 1.25,
    marginBottom: 1,
  },
  title: {
    color: '#FFFFFF',
    fontWeight: Typography.extrabold,
    fontSize: 15,
    lineHeight: 18,
  },
  description: {
    color: 'rgba(255,255,255,0.72)',
    fontWeight: Typography.medium,
    fontSize: 13,
    lineHeight: 17,
    marginTop: 2,
  },
});
